import React, {
  Component
} from 'react';
import {
  HashRouter as Router,
  Route,
  Switch
} from "react-router-dom";

import './style/bootstrap.min.css';
import './style/fontawesome/css/all.css';
import 'rc-notification/assets/index.css';
import './style/animate.css';
import './style/common.css';

import Console from './apps/console/console';
import Home from './apps/site/home';
import Color from './apps/site/color';
import Browsers from './apps/site/browsers';
import Declaration from './apps/site/sign/declaration';
import Register from './apps/site/sign/register';
import Forgot from './apps/site/sign/forgot';
import Resetpassword from './apps/site/sign/resetpassword';
import WorkstationRegister from './apps/workstation/register';
import WorkstationRegisterSuccess from './apps/workstation/register_success';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exact: true,
      page_title: '影像数据分析平台'
    };


    document.title = this.state.page_title;

  }
  render() {
    return (
      <Router>
      <div className="App">
        <Switch>
          <Route path="/Console" component={Console} />
          <Route path="/" component={Home} exact />
          <Route path="/sign/register" component={Register} exact />
          <Route path="/sign/forgot" component={Forgot} exact />
          <Route path="/sign/resetpassword" component={Resetpassword} exact />
          <Route path="/sign/declaration" component={Declaration} exact />
          <Route path="/color" component={Color} exact />
          <Route path="/browsers" component={Browsers} exact />
          <Route path="/workstation/register" component={WorkstationRegister} exact />
          <Route path="/workstation/register_success" component={WorkstationRegisterSuccess} exact />
        </Switch>
      </div>
      </Router>
    );
  }
}


export default App;


// WEBPACK FOOTER //
// ./src/App.js